module.exports = __webpack_public_path__ + "static/media/img82.cf75046c.jpg";